/* jshint esnext: true */
/**
 * offcanvas menu
 ***********************/
$(() => {
  var
    $body = $('body'),
    $toggle = $('#offcanvasMenu-toggle'),
    $wrap = $('#offcanvasMenu-wrap'),
    $menu = $('#offcanvasMenu'),
    activeClass = 'js-offcanvas-active',
    transEnd = 'transitionend webkitTransitionEnd oTransitionEnd';

  $toggle.on('click', function (ev) {
    ev.preventDefault();

    $body.toggleClass(activeClass);
    $menu.css({display: 'block'});
    return false;
  });

  $wrap.on('click', ev => {
    // only work $toggle is active
    if (!$body.hasClass(activeClass)) return;
    ev.preventDefault();

    $body.removeClass(activeClass);

    return false;
  });

  $wrap.on('touchmove', ev => {
    if (!$body.hasClass(activeClass)) return;
    ev.preventDefault();

    return false;
  });

  $wrap.on(transEnd, () => {
    if ($body.hasClass(activeClass)) return;
    $menu.css({display: 'none'});
  });
});
